// Scoring engine for the finalized V1 content package.
// Each option carries PRIMARY +2 / SECONDARY +1 weights in the decoder data.
// Tie-handling per package: highest total wins; ties compare PRIMARY-match
// counts; if still tied, the adaptive tie-break screen decides — never
// question order, Question 5, or first-listed-pattern.

export function tallyScores(decoder, answers) {
    const byOptionId = new Map(
        decoder.questions.flatMap((q) => q.options.map((o) => [o.id, o])),
    );
    const scores = {};
    for (const answer of answers) {
        const option = byOptionId.get(answer.id);
        if (!option) continue;
        for (const [key, points] of Object.entries(option.scores)) {
            scores[key] = (scores[key] || 0) + points;
        }
    }
    return scores;
}

export function primaryMatches(decoder, answers) {
    const byOptionId = new Map(
        decoder.questions.flatMap((q) => q.options.map((o) => [o.id, o])),
    );
    const counts = {};
    for (const answer of answers) {
        const option = byOptionId.get(answer.id);
        if (!option) continue;
        for (const [key, points] of Object.entries(option.scores)) {
            if (points === 2) counts[key] = (counts[key] || 0) + 1;
        }
    }
    return counts;
}

export function resolveOutcome(decoder, scores, primaries) {
    const top = Math.max(...decoder.patterns.map((p) => scores[p.key] || 0));
    const tied = decoder.patterns.filter((p) => (scores[p.key] || 0) === top);
    if (tied.length === 1) return { type: "pattern", pattern: tied[0] };

    const topPrimaries = Math.max(...tied.map((p) => primaries[p.key] || 0));
    const stillTied = tied.filter(
        (p) => (primaries[p.key] || 0) === topPrimaries,
    );
    if (stillTied.length === 1) return { type: "pattern", pattern: stillTied[0] };

    return { type: "tie", tied: stillTied };
}

export function resolvePatternByKey(decoder, key) {
    return decoder.patterns.find((p) => p.key === key);
}
